import { makeVar } from "@apollo/client";

export const pageTitleVar = makeVar<string>("");
